import { type ReactNode } from 'react';
import { Offcanvas } from 'react-bootstrap';

interface NtxOffcanvasProps {
  title?: string;
  // placement?: 'top' | 'bottom' | 'end' | 'start';
  placement?: 'end' | 'start';
  children: ReactNode;

  show: boolean;
  handleClose: () => void;

  showHeader: boolean;
  width: string;
}
const NtxOffcanvas = ({
  title,
  children,
  show,
  handleClose,
  placement,
  showHeader = true,
  width = '20%'
}: NtxOffcanvasProps) => {
  return (
    <>
      <Offcanvas show={show} onHide={handleClose} placement={placement ?? 'start'}>
        {/* <Offcanvas.Header closeButton> */}
        {showHeader && (
          <Offcanvas.Header>
            <Offcanvas.Title>{title}</Offcanvas.Title>
          </Offcanvas.Header>
        )}
        <Offcanvas.Body>{children}</Offcanvas.Body>
      </Offcanvas>

      <style>
        {`

          .offcanvas-backdrop.show{
          opacity:0.5
          }
          
          .offcanvas.offcanvas-end {
                top: 0;
                right: 0;
                width: ${width};
                border-left: var(--bs-offcanvas-border-width) solid var(--bs-theme);
                transform: translateX(100%);
          }
          .offcanvas.offcanvas-start {
             top: 0;
             left: 0;
             width: ${width};
             border-right: var(--bs-offcanvas-border-width) solid var(--bs-theme);
             transform: translateX(-100%);
          }
          `}
      </style>
    </>
  );
};

export default NtxOffcanvas;
